(function() {
	
	var Texture = include("PIXI.Texture"),
		Application = include("springroll.Application"),
		Sprite = include("PIXI.Sprite"),
		Polygon = include("heist.Polygon");
	
	//class for an item in the level of Stage 1 - stealth
	var LevelItem = function(data, config)
	{
		Sprite.call(this, Texture.fromFrame(config.frame || data.id));
		
		this.position.x = data.x;
		this.position.y = data.y;
		
		if(data.scaleX !== undefined)
			this.scale.x = data.scaleX;
		else if(data.width !== undefined)
			this.width = data.width;
		if(data.scaleY !== undefined)
			this.scale.y = data.scaleY;
		else if(data.height !== undefined)
			this.height = data.height;
		
		this.type = config.type;
		
		if(config.collision)
		{
			this.wallArea = [];
			var collision = config.collision;
			if(!Array.isArray(collision))
				collision = [collision];
			for(var i = 0; i < collision.length; ++i)
			{
				var poly = new Polygon(collision[i], this.scale);
				if(collision[i].isRectangle)
					poly.isRectangle = true;
				poly.setOrigin(data.x, data.y);
				this.wallArea.push(poly);
			}
		}
		else
			this.wallArea = null;
		
		this.worldPos = this.position.y + (config.height ? config.height : this.height);
	};
	
	// Extend MovieClip
	var s = Sprite.prototype;
	var p = LevelItem.prototype = Object.create(s);
	
	p.destroy = function()
	{
		if(this.wallArea)
		{
			for(var i = 0; i < this.wallArea.length; ++i)
				this.wallArea[i].destroy();
			this.wallArea = null;
		}
		s.destroy.call(this);
	};
	
	namespace('heist').LevelItem = LevelItem;
}());